import React from 'react';
import './NoStreaming.css'; // Make sure to create this CSS file for styles

const NoStreaming = () => {
    return (
        <div className="no-streaming-container">
            <div className="message-box">
                <h1>No Streaming is Live</h1>
                <p>We are currently not streaming. Please check back later.</p>
            </div>
        </div>
    );
};

export default NoStreaming;
